<template>
  <component
    v-for="modal in resolvedModals"
    :is="modal.component"
    :key="modal.id"
    v-bind="modal.props ?? {}"
    is-visible
    :stack-depth="modal.depth"
    @cancel="cancelModal(modal.id)"
    @close="closeModal(modal.id)"
    @confirm="confirmModal(modal.id)"
  >
    <template v-for="(slotFn, name) in modal.slots ?? {}" #[name]="slotProps">
      <component :is="slotFn" v-if="slotFn" :key="name" v-bind="slotProps" />
    </template>
  </component>
</template>

<script lang="ts" setup>
const { activeModals, cancelModal, closeModal, confirmModal, resolvedModals } = useModal()
const route = useRoute()

watch(
  () => route.path,
  (path) => {
    for (const modal of [...activeModals.value]) {
      if (modal.persistent) continue
      if (modal.routePath === path) continue

      closeModal(modal.id)
    }
  },
)
</script>
